import React from 'react';
import './index.sass';

// inline-иконки для компетенций
const Ic = {
  shop:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l1-5h16l1 5"/><path d="M4 9v11h16V9"/><path d="M9 20v-6h6v6"/></svg>,
  bpm:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  ledger: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16v4H4z"/><path d="M6 8v12M18 8v12M4 20h16"/></svg>,
  doc:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
  bi:     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><rect x="7" y="12" width="3" height="6"/><rect x="12" y="8" width="3" height="10"/><rect x="17" y="5" width="3" height="13"/></svg>,
  web:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20"/></svg>,
  mobile: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="7" y="2" width="10" height="20" rx="2"/><path d="M12 18h.01"/></svg>,
  cloud:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10a6 6 0 0 0-11.6-2A4.5 4.5 0 0 0 7 17h11a4 4 0 0 0 0-7z"/></svg>,
  crm:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
};

const competences = [
    { icon: Ic.shop,   title: 'Торговые и электронные площадки' },
    { icon: Ic.bpm,    title: 'Управление бизнес-процессами (BPM)' },
    { icon: Ic.ledger, title: 'Учётные системы различных профилей' },
    { icon: Ic.doc,    title: 'Системы электронного документооборота' },
    { icon: Ic.bi,     title: 'Аналитика и корпоративные хранилища данных' },
    { icon: Ic.web,    title: 'Интерактивные веб-системы и порталы' },
    { icon: Ic.mobile, title: 'Мобильные приложения' },
    { icon: Ic.cloud,  title: 'Облачные сервисы и микросервисы' },
    { icon: Ic.crm,    title: 'CRM и системы персонализированного маркетинга' },
];

const Competence = () => {
    return (
        <section className="Competence">
            <div className="container container--slim Competence__Container">
                <div className="Competence__Left">
                    <span className="Competence__Eyebrow">Экспертиза</span>
                    <h2 className="Competence__Title">
                        Широкая <span className="Text-Accent">предметная экспертиза</span>
                    </h2>
                    <p className="Competence__Text">
                        За 15+ лет мы накопили глубокий опыт в десятках предметных областей.
                        Это позволяет нам быстро погружаться в задачу заказчика и предлагать
                        профессиональное решение — а не учиться на его проекте.
                    </p>
                </div>
                <div className="Competence__Right">
                    <div className="Competence__Grid">
                        {
                            competences.map(({title, icon}, index) => (
                                <div className="Competence__Item" key={index}>
                                    <span className="Competence__Item-Icon">{icon}</span>
                                    <span className="Competence__Item-Title">{title}</span>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Competence;
